module.exports = __webpack_public_path__ + "static/media/img_coupon3.a0fad7d9.png";